// extracted by mini-css-extract-plugin
module.exports = {"main":"TraitScoreLarge_main__c6uGV","selected":"TraitScoreLarge_selected__S_QzS","unselected":"TraitScoreLarge_unselected__30Vn9"};